import React from 'react';
import { languagePageData } from './markup'
import Index from '../index'

export default ({ location }) => {
  return (<Index pageData={languagePageData} location={location} />)
}